export default __webpack_public_path__ + "d07b9e244835d5e7f5ec54f071daceeb.svg";